import { useMemo } from 'react';
import handleKeyboardEvent from './handleKeyboardEvent';
import handleInputChange from './handleInputChange';
const useChangeEvents = ({ suggestions, suggestedValue, setSuggestedValue, enteredValue, setEnteredValue, onSelection, isNavigated, setIsNavigated, isToggled, setOn, setOff }) => {
    const handleKeyDown = useMemo(() => handleKeyboardEvent({
        suggestions,
        suggestedValue,
        enteredValue,
        setSuggestedValue,
        setEnteredValue,
        onSelection,
        setIsNavigated,
        isToggled,
        setOn,
        setOff
    }), [
        suggestions,
        suggestedValue,
        enteredValue,
        setSuggestedValue,
        setEnteredValue,
        onSelection,
        setIsNavigated,
        isToggled,
        setOn,
        setOff
    ]);
    const handleChange = useMemo(() => handleInputChange({
        setEnteredValue,
        setSuggestedValue,
        isNavigated,
        setIsNavigated,
        setOn
    }), [setEnteredValue, setSuggestedValue, isNavigated, setIsNavigated, setOn]);
    return { handleKeyDown, handleChange };
};
export default useChangeEvents;
//# sourceMappingURL=useChangeEvents.js.map